import { Link } from "react-router-dom";

export function Footer() {
    return (
        <footer className="border-t border-nm-line bg-nm-bg">
            <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 py-8 text-sm text-nm-muted sm:flex-row sm:items-center sm:justify-between">
                <p className="font-medium text-nm-ink">Network Mastery</p>
                <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                    <a
                        href="tel:+34694406037"
                        className="transition-colors duration-150 hover:text-nm-accent"
                        data-testid="footer-phone"
                    >
                        +34 694 406 037
                    </a>
                    <Link
                        to="/privacidad"
                        className="transition-colors duration-150 hover:text-nm-accent"
                        data-testid="footer-privacy-link"
                    >
                        Privacidad
                    </Link>
                    <span className="text-nm-muted/70">© {new Date().getFullYear()}</span>
                </div>
            </div>
        </footer>
    );
}
